import userAnalyticsHtml from '../stitch/user-analytics-insights.html?raw'
import projectAnalyticsHtml from '../stitch/project-performance-analytics.html?raw'
import taskAnalyticsHtml from '../stitch/task-performance-intelligence.html?raw'
import jobAnalyticsHtml from '../stitch/job-productivity-intelligence.html?raw'
import communicationAnalyticsHtml from '../stitch/bridge-communication-analytics.html?raw'

export const ANALYTICS_MODULE_ORDER = ['user', 'project', 'task', 'job', 'communication']

export const STITCH_ANALYTICS_SCREENS = {
  user: {
    title: 'User Analytics Insights',
    html: userAnalyticsHtml,
  },
  project: {
    title: 'Project Performance Analytics',
    html: projectAnalyticsHtml,
  },
  task: {
    title: 'Task Performance Intelligence',
    html: taskAnalyticsHtml,
  },
  job: {
    title: 'Job Productivity Intelligence',
    html: jobAnalyticsHtml,
  },
  communication: {
    title: 'Bridge Communication Analytics',
    html: communicationAnalyticsHtml,
  },
}

export function getAnalyticsScreen(moduleKey) {
  return STITCH_ANALYTICS_SCREENS[moduleKey] || STITCH_ANALYTICS_SCREENS.user
}
